import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-1471f00d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  id: "header",
  class: "br-da-"
}
const _hoisted_3 = {
  id: "username",
  class: "bb-da-"
}
const _hoisted_4 = { class: "bb-da-" }
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Study Stats:")
], -1))
const _hoisted_7 = { class: "app" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, null, -1))
const _hoisted_9 = { class: "" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-align-left" }, "Words Count:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-align-left" }, "Studies Count:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-align-left" }, "Remembers Count:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-align-left" }, "Cant Remembers Count:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-align-left" }, "Latest Created At:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-align-left" }, "Latest Studied At:", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Flashcard App", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "320",
  alt: "Wordmider logo",
  src: _imports_0
}, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.username), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "app",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
        }, "Logout")
      ])
    ]),
    (_ctx.stats)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("tbody", _hoisted_9, [
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", null, _toDisplayString(_ctx.toFormattedString(_ctx.stats.wordsCount)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", null, _toDisplayString(_ctx.toFormattedString(_ctx.stats.studiesCount)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", null, _toDisplayString(_ctx.toFormattedString(_ctx.stats.remembersCount)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_13,
                _createElementVNode("td", null, _toDisplayString(_ctx.toFormattedString(_ctx.stats.cantRemembersCount)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", null, _toDisplayString(_ctx.toFixedLen(_ctx.stats.latestCreatedAt)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_15,
                _createElementVNode("td", null, _toDisplayString(_ctx.toFixedLen(_ctx.stats.latestStudiedAt)), 1)
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
  ]))
}